import { render, staticRenderFns } from "./clouddetea.vue?vue&type=template&id=0a673aef&scoped=true"
import script from "./clouddetea.vue?vue&type=script&lang=js"
export * from "./clouddetea.vue?vue&type=script&lang=js"
import style0 from "./clouddetea.vue?vue&type=style&index=0&id=0a673aef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a673aef",
  null
  
)

export default component.exports